"use client";

/* eslint-disable jsx-a11y/anchor-is-valid */
import AmpService, { AMP_CATEGORY_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import classnames from "classnames";
import PAText from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import Link from "next/link";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import CategoryViewItem from "../../../component/categories-viewer/CategoryViewItem";
import { isEmpty } from "../../../util/lodash/isEmpty";
import spriteStyles from "../category-sprite.module.scss";
import { mapSaleTagValue } from "../home-utils";
import styles from "./home-category.module.scss";

export default function RenderNewRow(props: any) {
  const {
    params, isTopSelling, getImgDimensions, departmentId,
  } = props;
  const {
    categoryImageSpriteCss, obj, key, tier0, tier1,
  } = params;
  const {
    classGrid = "small", t1, url, t2Class, name,
  } = obj;
  const categoryAltText = `High quality ${name} available on PartsAvatar`;
  const { t } = useTranslation("category-map");
  const homeT = (_: string, options) => t(_, { ...options, ns: "home" });

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);

  const isMuffler = isTopSelling && obj.tier0 === "Replacement Parts" && obj.tier1 === "Exhausts" && obj.tier2 === "Mufflers";
  const { saleTagValue, saleTagTitle } = obj;
  const onClick = () => AmpService.categoryClick({ tier0, tier1 }, AMP_CATEGORY_LOCATIONS.MAIN_CATEGORY_GRID);

  const { width, height } = getImgDimensions(classGrid);

  const renderItem = (
    <span
      className="pointer"
      onClick={onClick}
      title={`Find Trustworthy ${t1 || name} for Optimal Vehicle Performance`}
    >
      {
        obj.imageUrl
          ? (
            <Image
              className="img"
              src={`${process.env.NEXT_PUBLIC_CMS}/${obj.imageUrl}`}
              width={width}
              height={height}
              alt={categoryAltText}
              title={categoryAltText}
              unoptimized
            />
          ) : <div className={`${spriteStyles.category_sprite_icon} ${categoryImageSpriteCss} ${spriteStyles[classGrid]} ${styles[classGrid]} ${spriteStyles[t2Class]}`} />
      }

      <div className={styles.category_text}>

        <PAText component="span" className={`m-0 ${styles.category_name}`}>{t(t1 || name)}</PAText>
      </div>

      <HideIf show={saleTagValue && saleTagValue !== 0 && saleTagTitle}>

        <div className={`${styles.saleBadge} ${styles[saleTagTitle]}`}>
          {mapSaleTagValue(saleTagTitle, saleTagValue, homeT)}
        </div>
      </HideIf>
    </span>
  );

  // Todo: Need to remove this from CMS. it was added just for hotfix
  if (isMuffler) {
    return null;
  }
  if (!isEmpty(url) && !selectedVehicle) {
    return (
      <div
        key={key}
        className={`${classGrid} ${styles[classGrid]} ${styles.col_item}`}
        style={{ minWidth: "calc(15 * var(--safari-root-font, 10px))" }}
      >

        <Link href={url} data-testid="tier1-category-desktop">
          {renderItem}
        </Link>
      </div>
    );
  }
  return (

    <CategoryViewItem
      key={key}
      categoryObj={{
        tier0: departmentId || obj.tier0,
        tier1: obj.t1 || obj.tier1,
        tier2: obj.tier2,
      }}
      className={classnames(`${classGrid} ${styles[classGrid]} ${styles.col_item} ${styles.category_no_link}`)}
    >
      {renderItem}
    </CategoryViewItem>
  );
}
